import Icon from '../components/Icon.vue'

Icon.register({
  hamsa: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M509.3 307.3C504.3 295.6 492.8 288 480 288H416V80C416 58 398 40 376 40S336 58 336 80V214C336 219.5 331.5 224 326 224H306C300.5 224 296 219.5 296 214V40C296 18 278 0 256 0S216 18 216 40V214C216 219.5 211.5 224 206 224H186C180.5 224 176 219.5 176 214V80C176 58 158 40 136 40S96 58 96 80V288H32C19.3 288 7.7 295.6 2.7 307.3A32-32 0 0 1 8.6 341.8L111.3 451.9C147 490.1 199.7 512 256 512S365 490.1 400.7 451.9L503.4 341.8A32-32 0 0 1 509.3 307.3zM256 416C203 416 160 352 160 352S203 288 256 288 352 352 352 352 309 416 256 416zM256 320C238.3 320 224 334.3 224 352S238.3 384 256 384 288 369.7 288 352 273.7 320 256 320z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/hamsa.js
// module id = Jg6W
// module chunks = 144